import { Errors, ErrorsDescription, TErrorDescription } from '@goodtimeio/storm/errors';

export const ERROR: Record<string, number> = Errors;

export const ERROR_DESCRIPTION: TErrorDescription = ErrorsDescription;
